import { FC, useState } from 'react';
import { Issue } from '../../../utils/model';
import {
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { readableTime } from '../../../utils/readableTime';
import { styled } from '@mui/material/styles';
import { IssueStateLabel } from './IssueStateLabel';
import { dateFilter } from '../../../utils/trackingDateUtils';
import { EstimateIssueModal } from './EstimateIssueModal';

interface IssuesTablesProps {
  issues: Issue[];
  pmIssue?: Issue;
  from: Date;
  to: Date;
}

const PaperGray = styled(Paper)(() => ({
  backgroundColor: '#f4f2f5',
}));

export const IssuesTables: FC<IssuesTablesProps> = ({ from, to, pmIssue, issues }) => {
  const [currentIssue, setCurrentIssue] = useState<Issue | undefined>();
  if (issues.length === 0) return <></>;
  return (
    <>
      {currentIssue && (
        <EstimateIssueModal
          issue={currentIssue}
          onClose={() => setCurrentIssue(undefined)}
          from={from}
          to={to}
        />
      )}
      <TableContainer component={PaperGray}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Dev issue</TableCell>
              <TableCell>Project</TableCell>
              <TableCell>State</TableCell>
              <TableCell align="right">Milestone</TableCell>
              <TableCell align="right">Actual Spend</TableCell>
              <TableCell align="right">Total Spend</TableCell>
              <TableCell align="right">Estimate</TableCell>
              <TableCell align="right">Update Date</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {issues.map((row) => (
              <TableRow
                key={`${row.iid}-${row.project.fullPath}-${row.project.name}`}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  <a href={row.webUrl} target="_blank" rel="noopener noreferrer">
                    {row.title}
                  </a>
                  <Button
                    variant="outlined"
                    sx={{ ml: 1 }}
                    onClick={() => setCurrentIssue(row)}
                  >
                    TimeLogs
                  </Button>
                </TableCell>
                <TableCell align="left">
                  <a href={row.project.webUrl} target="_blank" rel="noopener noreferrer">
                    {row.project.name}
                  </a>
                </TableCell>
                <TableCell align="right">
                  <IssueStateLabel issue={row} />
                </TableCell>
                <TableCell
                  align="right"
                  style={{
                    color: pmIssue
                      ? row.milestone?.title === pmIssue.milestone?.title
                        ? 'black'
                        : 'red'
                      : 'black',
                  }}
                >
                  {row.milestone?.title ?? 'No Sprint'}
                </TableCell>
                <TableCell align="right">
                  {readableTime(
                    row.timeLogs.reduce(
                      (acc, i) =>
                        acc +
                        (dateFilter(i.spentAt, from, to) ? i.timeSpent * 60 * 60 : 0),
                      0,
                    ),
                  )}
                </TableCell>
                <TableCell align="right">
                  {readableTime(row.time_stats?.total_time_spent ?? 0)}
                </TableCell>
                <TableCell align="right">
                  {readableTime(row.time_stats.time_estimate ?? 0)}
                </TableCell>
                <TableCell align="right">{row.updatedAt.toLocaleDateString()}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};
